import { JwtUtils } from './../../../auth/utilities/jwtUtils';
import { AuthService } from './../../../auth/auth.service';
import { Component, EventEmitter, Input, NgZone, Output, ViewChild, OnDestroy } from '@angular/core';
import { TelerikReportViewerComponent } from '@progress/telerik-angular-report-viewer';
import { environment } from '../../../../environments/environment';
import { ConsoleLogger } from '../../utilities/console-logger';

// Safely wrap the Telerik viewer's own ngOnDestroy so internal dispose errors
// (e.g. perspectiveManager.dispose not being a function) do not break navigation.
const originalTelerikNgOnDestroy = (TelerikReportViewerComponent as any).prototype && (TelerikReportViewerComponent as any).prototype.ngOnDestroy;
if (originalTelerikNgOnDestroy) {
    (TelerikReportViewerComponent as any).prototype.ngOnDestroy = function () {
        try {
            originalTelerikNgOnDestroy.apply(this, arguments);
        } catch (error) {
            ConsoleLogger.logInfo('Error inside TelerikReportViewerComponent.ngOnDestroy (swallowed):', error);
        }
    };
}

@Component({
    selector: 'app-telerik-report-viewer',
    templateUrl: './report-viewer.component.html',
    styleUrls: ['./report-viewer.component.css']
})

export class ReportViewerComponent implements OnDestroy {
    @ViewChild('viewer1') viewer: TelerikReportViewerComponent;
    @Input() reportName: string;
    @Input() parameters: Array<any>;
    @Input() parametersAreaVisible: boolean = true;
    @Output() public reportError = new EventEmitter<void>();
    @Output() public reportRendered = new EventEmitter<void>();

    constructor(private authService: AuthService, private ngZone: NgZone) {

    }

    public onReportError = () => {
        this.ngZone.run(() => this.reportError.emit());
    }

    public onReportRendered = () => {
        this.ngZone.run(() => this.reportRendered.emit());
    }

    get authToken() {
        return JwtUtils.accessToken;
    }

    get reportParams() {
        const params = {};
        return this.parameters.reduce((obj, item) => {
            return {
              ...obj,
              [item['name']]: item.val,
            };
          }, params);

    }

    serviceUrl: string = environment.telerikEmbeddedUrl;

    title = "Report Viewer";

    // Render available-values parameter editors (e.g. Company ID) as Kendo combo box
    // dropdowns instead of the default list views. Multi-value parameters become a
    // MultiSelect dropdown with type-ahead filtering; single-value ones become a ComboBox.
    parameterEditorSettings = {
        editors: {
            singleSelect: 'COMBO_BOX',
            multiSelect: 'COMBO_BOX'
        }
    };

    viewerContainerStyle = {
        position: 'absolute',
        left: '5px',
        right: '5px',
        top: '40px',
        bottom: '5px',
        overflow: 'hidden',
        clear: 'both',
        ['font-family']: 'ms sans serif'
    };

    ready() {
        ConsoleLogger.logInfo('ready');
    }

    viewerToolTipOpening(e: any, args: any) {
        ConsoleLogger.logInfo('viewerToolTipOpening ' + args.toolTip.text);
    }

    ngOnDestroy(): void {
        try {
            ConsoleLogger.logInfo('Disposing Telerik Report Viewer');

            if (this.viewer) {
                const anyViewer: any = this.viewer as any;

                if (anyViewer.dispose && typeof anyViewer.dispose === 'function') {
                    anyViewer.dispose();
                }

                (this.viewer as any) = null;
            }
        } catch (error) {
            ConsoleLogger.logInfo('Error disposing Telerik Report Viewer:', error);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/report-viewer/report-viewer.component.ts